import { BadgeType } from 'components/badge/badge';

export const getOrderTransactionStateBadgeType = (stateId: number): BadgeType => {
    if (stateId === 1) return 'success'; // تکمیل شده
    if ([ 3, 4, 5, 6, 7, 8, 10, 11, 12].includes(stateId)) return 'waiting'; // در انتظارها
    if ([9, 14].includes(stateId)) return 'error'; // رد شده / منقضی شده
    if (stateId === 13 || stateId===2) return 'info'; // عودت شده
    return 'secondary'; // پیش‌فرض
};
